// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__2Th6L","active":"Tabs_active__2OrpB"};